import React, { useState } from "react";
import {
  List,
  useTable,
  TableColumnType,
  Button,
  Table,
  SaveButton,
  Form,
  Input,
  BooleanField,
} from "@pankod/refine-antd";
import { useExport } from "@pankod/refine-core";
import { ISearch } from "type";

export const UniverseTradeList = () => {
  const [query, setQuery] = useState("");
  const { tableProps, searchFormProps } = useTable({
    queryOptions: { retry: false },
    onSearch: (values: ISearch) => {
      return [
        {
          field: "q",
          operator: "contains",
          value: values.q ? values.q : null,
        },
      ];
    },
  });
  const { triggerExport } = useExport({
    filters: [
      {
        field: "q",
        operator: "contains",
        value: query,
      },
    ],
  });
  const columns = React.useMemo<TableColumnType<any>[]>(
    () => [
      {
        dataIndex: "bot_subscription_id",
        title: "Bot-subscription Id",
        type: "number",
        width: 150,
        align: "center",
        headerAlign: "center",
        ellipsis: {
          showTitle: false,
        },
        fixed: "left",
      },
      {
        dataIndex: "snapped_at",
        title: "Snapped At",
        width: 280,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "id",
        title: "Balance Flow Id",
        width: 180,
        align: "center",
        headerAlign: "center",
      },

      {
        dataIndex: "flow_type_value",
        title: "Flow Type Value",
        type: "number",
        width: 140,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "flow_type",
        title: "Flow Type",
        type: "string",
        width: 180,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "is_long",
        title: "Is Long",
        width: 100,
        align: "center",
        headerAlign: "center",
        render: (_, record) => {
          return (
            <BooleanField
              value={record.is_long === true}
              trueIcon={"True"}
              falseIcon={"False"}
            />
          );
        }
      },
      {
        dataIndex: "account_id",
        title: "Account Id",
        type: "number",
        width: 190,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "trade_id",
        title: "Trade Id",
        type: "number",
        width: 180,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "order_id",
        title: "Order Id",
        width: 190,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "symbol_id",
        title: "Symbol",
        width: 160,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "change",
        title: "Balance Flow Change",
        type: "number",
        width: 190,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "changed",
        title: "Settlement Changed",
        type: "number",
        width: 150,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "token_id",
        title: "Token Id",
        type: "string",
        width: 100,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "token_name",
        title: "Token Name",
        width: 100,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "price",
        title: "Price",
        width: 150,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "quantity",
        title: "Quantity",
        type: "number",
        width: 150,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "amount",
        title: "Amount",
        type: "number",
        width: 160,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "fee_token_id",
        title: "Fee Token",
        width: 150,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "fee",
        title: "Fee",
        width: 120,
        align: "center",
        headerAlign: "center",
        ellipsis: {
          showTitle: false,
        },
      },
      {
        dataIndex: "match_order_id",
        title: "Match Order Id",
        type: "number",
        width: 180,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "match_account_id",
        title: "Match Account Id",
        type: "number",
        width: 180,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "maker_rebate",
        title: "Maker Rebate",
        width: 120,
        align: "center",
        headerAlign: "center",
        ellipsis: {
          showTitle: false,
        },
      },
      {
        dataIndex: "order_type",
        title: "Order Type",
        width: 150,
        align: "center",
        headerAlign: "center",
        ellipsis: {
          showTitle: false,
        },
      },
      {
        dataIndex: "side",
        title: "Order Side",
        width: 150,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "pnl",
        title: "Pnl",
        type: "number",
        width: 180,
        align: "center",
        headerAlign: "center",
      },
    ],
    []
  );

  return (
    <List
      headerButtons={({ defaultButtons }) => (
        <>
          {defaultButtons}
          <Form {...searchFormProps} layout="inline">
            <Form.Item name="q">
              <Input
                placeholder="Search by ..."
                onChange={(e) => {
                  setQuery(e.target.value);
                }}
              />
            </Form.Item>
            <SaveButton type="default" onClick={searchFormProps.form?.submit}>
              SEARCH
            </SaveButton>
          </Form>
          <Button type="primary" onClick={triggerExport}>
            EXPORT
          </Button>
        </>
      )}
    >
      <Table
        {...tableProps}
        bordered={true}
        rowKey="balance_flow_id"
        columns={columns}
        scroll={{ x: 1500 }}
        size="middle"
        pagination={{
          ...tableProps.pagination,
          position: ["bottomRight"],
          size: "default",
        }}
      ></Table>
    </List>
  );
};
